import React, { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../AdminComponent/BaseUrl';
import Loader from './Loader';
import decryptedvendorid from '../Utils/Vendorid';
import { useNavigate } from 'react-router-dom';

const ShippingDetails = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [value, setValue] = useState({
        order_id: '',
        tracking_id: '',
        shipping_service: ''
    });
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState({
        show: false,
        success: false,
        message: ''
    });

    // Handle form input changes
    const handleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    // Form validation
    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!value.order_id.trim()) {
            newErrors.order_id = "Order ID is required";
            isValid = false;
        }

        if (!value.tracking_id.trim()) {
            newErrors.tracking_id = "Tracking ID is required";
            isValid = false;
        }

        if (!value.shipping_service.trim()) {
            newErrors.shipping_service = "Shipping Service Name is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!validateForm()) return;
        
        setLoader(true);
        
        const data = {
            orderno: value.order_id,
            tracking_id: value.tracking_id,
            courier_comp: value.shipping_service
        };

        axios.post(`${BASE_URL}/update_order_shipping`, data)
            .then((res) => {
                setLoader(false);
                setSubmitStatus({
                    show: true,
                    success: true,
                    message: 'Shipping details updated successfully!'
                });
                
                // Reset form   
                setValue({
                    order_id: '',
                    tracking_id: '',
                    shipping_service: ''
                });
                
                // Reset success message after 3 seconds
                setTimeout(() => {
                    setSubmitStatus({
                        show: false,
                        success: false,
                        message: ''
                    });
                }, 3000);
            })
            .catch((err) => {
                console.log(err);
                setLoader(false);
                setSubmitStatus({
                    show: true,
                    success: false,
                    message: err.response?.data?.error || 'Failed to update shipping details. Please try again.'
                });
                
                // Reset error message after 3 seconds
                setTimeout(() => {
                    setSubmitStatus({
                        show: false,
                        success: false,
                        message: ''
                    });
                }, 3000);
            });
    };

    return (
        <div className="container-fluid page-body-wrapper">
            <div className="content-wrapper">
                <div className="back-navigation mb-4">
                    <button 
                        className="btn btn-link text-dark p-0" 
                        onClick={() => navigate('/vendor')}
                        style={{ fontSize: '1.2rem' }}
                    >
                        <i className="mdi mdi-arrow-left"></i> Back
                    </button>
                </div>
                
                <div className="row justify-content-center">
                    <div className="col-lg-8 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Update Shipping Details</h4>
                                <p className="card-description">
                                    Enter order ID, tracking information, and shipping service to update shipping details
                                </p>
                                
                                {submitStatus.show && (
                                    <div className={`alert ${submitStatus.success ? 'alert-success' : 'alert-danger'}`}>
                                        {submitStatus.message}
                                    </div>
                                )}
                                
                                <form className="forms-sample py-3" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="order_id">Order ID <span className="text-danger">*</span></label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="order_id" 
                                            placeholder="Enter Order ID" 
                                            name="order_id" 
                                            value={value.order_id} 
                                            onChange={handleChange} 
                                        />
                                        {errors.order_id && <span className="text-danger">{errors.order_id}</span>}
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="tracking_id">Tracking ID <span className="text-danger">*</span></label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="tracking_id" 
                                            placeholder="Enter Tracking ID" 
                                            name="tracking_id" 
                                            value={value.tracking_id} 
                                            onChange={handleChange} 
                                        />
                                        {errors.tracking_id && <span className="text-danger">{errors.tracking_id}</span>}
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="shipping_service">Shipping Service <span className="text-danger">*</span></label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="shipping_service" 
                                            placeholder="Enter Shipping Service Name" 
                                            name="shipping_service" 
                                            value={value.shipping_service} 
                                            onChange={handleChange} 
                                        />
                                        {errors.shipping_service && <span className="text-danger">{errors.shipping_service}</span>}
                                    </div>
                                    
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary mr-2">Submit</button>
                                        <button 
                                            type="button" 
                                            className="btn btn-light" 
                                            onClick={() => {
                                                setValue({
                                                    order_id: '',
                                                    tracking_id: '',
                                                    shipping_service: ''
                                                });
                                                setErrors({});
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loader && <Loader />}
        </div>
    );
};

export default ShippingDetails; 